import { useState } from 'react';
import { useObservedFieldValues } from '../SegmentFieldValues';
import type { SuggestedTextInputProps } from './suggested-text-input.types';
import { SuggestionInput } from './SuggestionInput';

interface ObservedSuggestedTextInputProps extends SuggestedTextInputProps {
  schemaId: string;
  field: string;
}

export function ObservedSuggestedTextInput({
  schemaId,
  field,
  value,
  ...inputProps
}: ObservedSuggestedTextInputProps) {
  const [suggestionsAreOpen, setSuggestionsAreOpen] = useState(false);
  const { suggestedOptions, observedValuesAreLoading } = useObservedFieldValues({
    schemaId,
    field,
    search: value,
    enabled: suggestionsAreOpen,
  });

  return (
    <SuggestionInput
      {...inputProps}
      value={value}
      suggestions={suggestedOptions}
      isLoading={observedValuesAreLoading}
      onOpenChange={setSuggestionsAreOpen}
      showCreateOption
    />
  );
}
